<script lang="ts">
    import { onMount } from 'svelte';

    import ColumnSelectSection from './ColumnSelectSection.svelte';
    import type { SelectManager } from './SelectManager';
    import { type CallbacksType, VALIDATE } from './types';

    export let callbacks: CallbacksType;
    export let sm: SelectManager;

    let formValidated = false;
    let usedOptions: string[] = [];

    const validateForm = () => {
        console.log('SVELTE: validateForm');
        let reasons: string[] = [];
        formValidated = sm.checkWarningsAndErrors();
        sm.updateStreetWarningDependsOnHouseNumberSelection();
        if (!formValidated) {
            reasons.push(VALIDATE.ERRORS_EXISTS);
            console.log('SVELTE: validateForm - reasons', reasons);
        }
        if (formValidated) {
            let usedNames = sm.getUsedOptionsNames();
            let existsX = usedNames.includes('x');
            let existsY = usedNames.includes('y');
            let existsXY = existsX && existsY;
            let existsCityStreet = usedNames.includes('city'); //  && usedNames.includes('street');
            let existsLinkXY = usedNames.includes('xy');
            if (!existsXY && !existsCityStreet && !existsLinkXY) {
                formValidated = false;
                reasons.push(VALIDATE.MISSING_XY_OR_CITY_STREET);
            }
            if (existsX && !existsY) {
                formValidated = false;
                reasons.push(VALIDATE.Y_SHOULD_BE_SELECTED_IF_X_IS_SELECTED);
            }
            if (existsY && !existsX) {
                formValidated = false;
                reasons.push(VALIDATE.X_SHOULD_BE_SELECTED_IF_Y_IS_SELECTED);
            }
        }
        sm = sm.reloadOptions();
        if (callbacks && typeof callbacks.onValidate === 'function') {
            console.log('SVELTE: validateForm - callback', formValidated);
            callbacks.onValidate(formValidated, reasons);
        }
    };

    onMount(() => {
        validateForm(); // initial check
    });

    $: usedOptions = sm.getUsedOptions();
</script>

<div class="all-columns">
    {#each sm.getSections() as section, index}
        <div class="one-column">
            <ColumnSelectSection
                title={section.label}
                section={section.id}
                bind:sm
                {validateForm}
            />
        </div>
    {/each}
</div>

<style>
    .all-columns {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(336px, 1fr));
        grid-gap: 20px 60px;
        margin-top: 1px;
    }
</style>
